import { Link } from "@tanstack/react-router";

export function Logo({
  size = 12,
  className = "",
  withWordmark = true,
}: {
  size?: number;
  className?: string;
  withWordmark?: boolean;
}) {
  return (
    <Link
      to="/"
      aria-label="Reality Twin — Home"
      className={`group flex shrink-0 items-center overflow-visible ${className}`}
    >
      {withWordmark ? <LogoWordmark size={size} /> : <LogoMark size={size} />}
    </Link>
  );
}

export function LogoMark({ size = 22, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 118 96"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={`shrink-0 text-foreground ${className}`}
    >
      <path d="M37.5 3.5h22.2l36.8 89H74.8l-7-17.6H29.4l-6.9 17.6H1L37.5 3.5Zm-2.7 55.1h27.6L48.6 23.8 34.8 58.6Z" />
    </svg>
  );
}

function LogoWordmark({ size = 12 }: { size?: number }) {
  return (
    <span
      className="flex shrink-0 items-center overflow-visible text-foreground"
      style={{
        height: `${size}px`,
        fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
        fontSize: `${size}px`,
        fontWeight: 900,
        lineHeight: 1,
        letterSpacing: "0.04em",
      }}
    >
      <span className="sr-only">Reality Twin</span>
      <span aria-hidden="true" className="flex shrink-0 items-center overflow-visible">
        <span>REAL</span>
        {/* The slanted bar is the "I" of REALITY. It's drawn, not typed, so any
            text extractor (and any model reading the DOM) would otherwise
            concatenate REAL+TY into "REALTY" — English for real estate, and the
            wrong entity signal. The clipped "I" restores the correct string
            without touching the visual mark. */}
        <span
          className="mx-[0.16em] block shrink-0 bg-current relative"
          style={{
            width: `${size * 0.2}px`,
            height: `${size * 0.98}px`,
            transform: "skewX(22deg)",
            transformOrigin: "center",
          }}
        >
          <span
            style={{
              position: "absolute",
              width: 1,
              height: 1,
              overflow: "hidden",
              clip: "rect(0 0 0 0)",
              whiteSpace: "nowrap",
            }}
          >
            I
          </span>
        </span>
        <span>TY</span>
      </span>
    </span>
  );
}
